import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "flex flex-col leading-tight text-left" }
const _hoisted_2 = { class: "xl:sf-pro-xs sf-pro-400-8 text-muted text-left" }

import { ROUTE_NAMES } from "@/constants/routeNames";
import { useI18n } from "vue-i18n";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoComponent',
  setup(__props) {

const { t } = useI18n();

function openMainPage() {
  router.push({ name: ROUTE_NAMES.HOME });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center xl:justify-center gap-3 xl:mx-auto h-full cursor-pointer",
    onClick: openMainPage
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      src: _imports_0,
      alt: "Лого",
      class: "xl:w-16 xl:h-16 w-[46px] h-[46px]"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-caudex xl:text-[27px] text-[16px]" }, "Fengshui Style", -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("feng_shui_tools")), 1)
    ])
  ]))
}
}

})